export const GET_ACCRUALS_TABLE = 'entities/GET_ACCRUALS_TABLE'
export const ADD_ACCRUALS_TABLE = 'entities/ADD_ACCRUALS_TABLE'
export const EDIT_ACCRUALS_TABLE = 'entities/EDIT_ACCRUALS_TABLE'
